var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.expressOrderDetails, border: "", size: "mini" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "goodsName",
              label: "物品名称",
              width: "180",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goods",
              label: "物品分类",
              width: "180",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "goodsWeight",
              label: "重量",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.goodsWeight) + "kg")])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "num",
              label: "件数",
              align: "center",
              width: "100",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "img", label: "物品照片", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.img
                      ? _c(
                          "div",
                          { staticClass: "flex-center" },
                          _vm._l(row.img.split(","), function (item) {
                            return _c(
                              "div",
                              { key: item, staticClass: "margin-right-10" },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                  },
                                  attrs: {
                                    src: item,
                                    "preview-src-list": row.img.split(","),
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _c("div", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }